import axios from '@/utils/request';
const checkLogin = () => {
  return new Promise((resolve, reject) => {
    const url: string = '/api/checkLogin';
    const args = {};
    axios.post(url, args).then((res: any) => {
      resolve(res);
    }).catch((err: any) => {
      reject(err);
    });
  });
};
export default checkLogin;
